import React from "react";
import { useRegisterStateValue } from "../../RegisterContext";
import AttendersForm from "./AttendersForm";
import { withLocalizeStrings } from "../../../languages/Localize";
import { Box, Flex } from "reflexbox/styled-components";
import styled from "styled-components";
import { Button } from "antd";
import { attendersValidator } from "../../register.validator";
import { Formik } from "formik";
import { Anchor } from "antd";

const { Link } = Anchor;

const StyledDescription = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.transparent};
    text-align: justify;
`;

const StyledButtonContainer = styled(Box)`
    text-align: center;
`;

const StyledButton = styled(Button)`
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.hover};
    width: 100%;
    height: 50px;
    border: none;
    font-size: inherit;
    text-transform: uppercase;
    &:focus,
    &:hover {
        background: ${({ theme }) => theme.colors.hover};
        color: ${({ theme }) => theme.colors.white};
    }
    &:active {
        background: ${({ theme }) => theme.colors.active};
        color: ${({ theme }) => theme.colors.white};
    }
`;
const StyledHeader = styled(Flex)`
    flex-direction: column;
    align-items: center;
    .divider {
        background: ${({ theme }) => theme.colors.white};
        width: 30px;
        height: 3px;
    }
`;

const StyledHeaderLabel = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
`;

const attenderInitialValue = {
    attender: ""
};

const StyledAnchor = styled(Anchor)`
    & {
        background: transparent;
    }
    && .ant-anchor-link-title {
        color: ${({ theme }) => theme.colors.white};
    }
    && .ant-anchor-ink::before {
        display: none;
    }
    && .ant-anchor-link {
        padding: 16px;
        text-align: center;
    }
`;

const AttenderScreen = ({ strings }) => {
    const { attendersForm, attendersFormValid, setAttendersFormValid, setAttenderAtForm, nextScreen, backScreen, initAttendersForm } =
        useRegisterStateValue();

    /* eslint-disable */
    React.useEffect(() => {
        if (attendersForm.attenders.length === 0) {
            initAttendersForm(attenderInitialValue, 10);
        }
    }, []);
    /* eslint-enable */

    return (
        <>
            <StyledHeader>
                <StyledHeaderLabel sx={{ fontWeight: "light", fontSize: [5, 6], mt: [3, 4], p: [1, 2] }}>
                    {strings.register.common.ATTENDER_HEADER}
                </StyledHeaderLabel>
                <div className="divider" />
            </StyledHeader>
            <Box className="required-label first" sx={{ m: [3, 4], px: [1, 2] }}>
                {strings.register.common.ATTENDER_REQUIRED_LABEL}
            </Box>
            <Formik initialValues={attendersForm} validationSchema={attendersValidator(strings)} isInitialValid={attendersFormValid}>
                {innerPops => (
                    <AttendersForm
                        onValidityChange={setAttendersFormValid}
                        onFormChange={setAttenderAtForm}
                        formData={attendersForm}
                        {...innerPops}
                    />
                )}
            </Formik>
            <StyledDescription
                sx={{
                    m: [3, 4],
                    px: [1, 2],
                    fontSize: [2, 3]
                }}>
                {strings.register.common.ATTENDER_INSTRUCTION}
            </StyledDescription>
            <StyledButtonContainer sx={{ marginTop: [3, 4], marginX: [3, 4], marginBottom: 0, px: [1, 2], fontSize: [2, 3] }}>
                <StyledButton disabled={!attendersFormValid} onClick={nextScreen}>
                    {strings.register.common.ATTENDER_BUTTON}
                </StyledButton>
            </StyledButtonContainer>
            <StyledAnchor className="link" affix={false} onClick={backScreen}>
                <Link title={strings.register.common.BACK_LABEL} />
            </StyledAnchor>
        </>
    );
};
export default withLocalizeStrings(AttenderScreen);
